// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import PageContent from "../containers/PageContent";



export default function PageView(props) {

    return (
        //<PageContainer title={pageTitle} showShopToolbar={false}>
        //    <PageContent navSection={props.match.params.navSection} />
        //</PageContainer>

        <PageContainer showShopToolbar={false}>
            <PageContent pageId={props.match.params.pageId} />
        </PageContainer>

    );
}




